'use strict';
import 'regenerator-runtime/runtime';
const React = require('react');
const BaseComponent = require('../../shared/base');
const client = require('../../../../sdk/client');

//= ====================================================================================================================
class AddressModalComponent extends BaseComponent {
    // TODO: se duplica informacion en el modal de direcciones
    constructor(props) {
        super(props);

        this.state = {
            addressList: {
                TotalRecords: 0
            },
            addressSelected: {
                alias: '',
                name: '',
                line1: '',
                city: '',
                country: '',
                postCode: '',
                state: ''
            },
            boolHideCloseButton: false
        };
        this.Cookies_SelectedAlias = 'SelectedAlias';
        this.Cookies_SelectedAddress = 'SelectedAddress';
        this.Cookies_SelectedState = 'SelectedState';
        this.Cookies_SelectedCity = 'SelectedCity';
        this.Cookies_SelectedZipcode = 'SelectedZipcode';
        this.Cookies_SelectedAddressLider = 'SelectedCustomAddress';
        this.Cookies_SelectedAddressRegion = 'SelectedCustomAddressRegion';
        this.Cookies_SelectedAddressPedido = 'SelectedCustomPedido';
        this.Cookies_SelectedAddressJSON = 'SelectedAddressJSON';
        this.Cookies_SelectedAddressDepot = 'SelectedAddressDepot';
        this.Cookies_SelectedAddressLatitude = 'SelectedAddressLatitude';
        this.Cookies_SelectedAddressLongitude = 'SelectedAddressLongitude';
        this.packageIdAlmacenes = process.env.ADMINISTRACION_ALMACENES;
    }

    // -----------------------------------------------------------------------------------------------------------------
    subGetAddressCookies() {
        var addressAlias = this.getCookie(this.Cookies_SelectedAlias);
        var addressLine1 = this.getCookie(this.Cookies_SelectedLine1);
        var addressId = this.getCookie(this.Cookies_SelectedAddress);
        var addressLatitude = this.getCookie(this.Cookies_SelectedAddressLatitude);
        var addressLongitude = this.getCookie(this.Cookies_SelectedAddressLongitude);
        var addressState = this.getCookie(this.Cookies_SelectedState);
        var addressCity = this.getCookie(this.Cookies_SelectedCity);
        var addressZipCode = this.getCookie(this.Cookies_SelectedZipcode);
        var addressCustomId = this.getCookie(this.Cookies_SelectedAddressLider);
        var addressRegion = this.getCookie(this.Cookies_SelectedAddressRegion);
        var pedidoInternetId = this.getCookie(this.Cookies_SelectedAddressPedido);
        var addressLiderConfiguration = this.getCookie(this.Cookies_SelectedAddressJSON);
        var addressLiderDepot = this.getCookie(this.Cookies_SelectedAddressDepot);

        document.getElementById('address-alias').innerText = (addressAlias != 'null') ? `${addressAlias}` : '';
        document.getElementById('address-name').innerText = `${addressCity}`;
        document.getElementById('address-name').setAttribute('addressId', addressId);
        document.getElementById('address-line1').value = addressLine1;
        document.getElementById('address-name').setAttribute('address-address1', addressLine1);
        document.getElementById('address-name').setAttribute('address-latitude', addressLatitude);
        document.getElementById('address-name').setAttribute('address-longitude', addressLongitude);
        document.getElementById('address-name').setAttribute('billing-address-lider', addressCustomId);
        document.getElementById('address-name').setAttribute('billing-address-region', addressRegion);
        document.getElementById('address-name').setAttribute('billing-address-pedido', pedidoInternetId);
        document.getElementById('address-name').setAttribute('address-lider-configuration', addressLiderConfiguration);
        document.getElementById('address-name').setAttribute('billing-address-branch', addressLiderDepot);
        document.getElementById('address-name').setAttribute('billing-address-test', 'Hola');
        document.getElementById('address-zipcode').innerText = `${addressZipCode}`;

        document.getElementById('custom-address-mobile').innerText = (addressAlias == 'null') ? '' : `${addressAlias}, ` + `${addressCity}, ${addressState}`;
    }

    // -----------------------------------------------------------------------------------------------------------------
    validateAddressInList(addressId) {
        return new Promise((resolve, reject) => {
            let isUserAddress = false;
            if (typeof this.props.user != 'undefined' && addressId != null) {
                client.Addresses.getUserAddresses(this.props.user.ID, function(err, addresses) {
                    if (err) {
                        console.log(err);
                        reject(err); 
                    }
                    if (
                        addresses != null && addresses.Records != null && addresses.Records.length > 0
                    ) {
                        //                              // We need to check that addressId is in users addresses.
                        addresses.Records.forEach(address => {
                            if (address.ID == addressId) {
                                isUserAddress = true;
                                // console.log('Address is in user addresses', addressId);
                            }
                        });
                    }
                    resolve(isUserAddress);
                });
            } else {
                resolve(isUserAddress);
            }
            
        });  
    }

    // -----------------------------------------------------------------------------------------------------------------
    async componentDidMount() {
        // console.log('AddressModalComponent componentDidMount REVIEW ADDRESS');
        var selectedAdress = this.getCookie(this.Cookies_SelectedAddress);
        //                                      //revisar si la direccion del cookie existe en la lista de direcciones del usuario
        try {
            const isAddressInList = await this.validateAddressInList(selectedAdress);
            if (
                selectedAdress != null && isAddressInList
            ) {
                this.subGetAddressCookies();
                // console.log("Got address from cookies")
            } else {
                // console.log('No address from cookies');
                this.setUserDefaultAddress();
                // console.log("Got and set default address from user addresses")
            }
        } catch (error) {
            console.log("Error al validar la dirección:", error);
        }
    }

    // -----------------------------------------------------------------------------------------------------------------
    renderTable() {
        if (this.state.addressList) {
            if (this.state.addressList.TotalRecords > 0) {
                return this.state.addressList.Records.map(function(element) {
                    return <div className='col-sm-12 col-md-6' key={element.ID} style={{ width: 100 + '%' }}>
                      <a data-id={element.ID} href='#' className='thumbnail' onClick={() => this.addressSelectionClickEvent(element)} data-dismiss='modal'>
                          <p style={{ marginBottom: 0 + 'px' }}>{element.Line2}</p>
                          <p style={{ marginBottom: 0 + 'px' }}>{element.Name.replace('|', ' ')}</p>
                          <p style={{ marginBottom: 0 + 'px' }}>{element.Line1}, {element.PostCode}</p>
                          <p style={{ marginBottom: 0 + 'px' }}>{element.City}, {element.State}, {element.Country == 'Mexico' ? 'México' : element.Country}</p>
                        </a>
                           </div>;
                }, this);
            } else {
                return <div className='col-sm-12 col-md-6' style={{ width: 100 + '%' }}>
                    <a href='/users/settings' className='thumbnail'>
                        <p>Sin direcciones disponibles</p>
                        <p>Ve a tu perfil y agrega una dirección de envío</p>
                  </a>
                </div>;
            }
        } else {
            return <div className='col-sm-12 col-md-6' style={{ width: 100 + '%' }}>
              <a href='/users/settings' className='thumbnail'>
                  <p>Sin direcciones disponibles</p>
                  <p>Ve a tu perfil y agrega una dirección de envío</p>
                </a>
                   </div>;
        }
    }

    // -----------------------------------------------------------------------------------------------------------------
    addressSelection(address) {
        document.getElementById('address-alias').innerText = (address.Line2 != null) ? `${address.Line2}` : '';
        document.getElementById('address-line1').value = address.Line1;
        document.getElementById('address-name').innerText = `${address.City}`;
        document.getElementById('address-name').setAttribute('addressId', address.ID);
        document.getElementById('address-name').setAttribute('address-lider-configuration', address.SpecialInstructions);
        document.getElementById('address-name').setAttribute('address-latitude', address.Latitude);
        document.getElementById('address-name').setAttribute('address-line1', address.Line1);
        document.getElementById('address-name').setAttribute('address-longitude', address.Longitude);
        document.getElementById('address-zipcode').innerText = address.PostCode;
        document.getElementById('custom-address-mobile').innerText = (address.Line2 == null) ? '' : `${address.Line2}, ` + `${address.City}, ${address.State}.`;
        document.cookie = `${this.Cookies_SelectedAlias}=${address.Line2}; path=/`;
        document.cookie = `${this.Cookies_SelectedLine1}=${address.Line1}; path=/`;
        document.cookie = `${this.Cookies_SelectedAddress}=${address.ID}; path=/`;
        document.cookie = `${this.Cookies_SelectedState}=${address.State}; path=/`;
        document.cookie = `${this.Cookies_SelectedCity}=${address.City}; path=/`;
        document.cookie = `${this.Cookies_SelectedZipcode}=${address.PostCode}; path=/`;
        document.cookie = `${this.Cookies_SelectedAddressLatitude}=${address.Latitude}; path=/`;
        document.cookie = `${this.Cookies_SelectedAddressLongitude}=${address.Longitude}; path=/`;
        document.cookie = `${this.Cookies_SelectedAddressJSON}=${address.SpecialInstructions}; path=/`;
    }

    // -----------------------------------------------------------------------------------------------------------------
    addressSelectionClickEvent(address) {
        //  Make close button visible again.
        this.setState({ boolHideCloseButton: false });

        var pathName = window.location.pathname;

        if (pathName == '/pedido-agil') {
            $('#modalChange').modal('show');
            $('#modalChange').removeClass('modal-backdrop');
            $('.modal-backdrop').hide();
        }
        this.addressSelection(address);
        this.subGetBillingAddress(address.ID);
    }

    // -----------------------------------------------------------------------------------------------------------------
    getCookie(name) {
        if(typeof window !== 'undefined'){
            var value = '; ' + document.cookie;
            var parts = value.split('; ' + name + '=');
            if (parts.length === 2) {
                return parts.pop().split(';').shift();
            }
        }
    }

    // -----------------------------------------------------------------------------------------------------------------
    getTableData() {
        var userId = this.props.user.ID != null ? this.props.user.ID : '';
        const promiseAddresses = new Promise((resolve, reject) => {
            client.Addresses.getUserAddresses(userId, function(err, result) {
                resolve(result);
            });
        });

        Promise.all([promiseAddresses]).then(response => {
            // console.log('address del user');
            // console.log(response);
            var objResponse = this.subCleanResults(response[0]);

            this.setState({ addressList: objResponse });
            const cookie = this.getCookie(this.Cookies_SelectedAddress);

            if (response[0]) {
                if (response[0].TotalRecords > 0 && cookie == undefined) {
                    this.state.addressSelected.alias = response[0].Records[0].Line2;
                    this.state.addressSelected.name = response[0].Records[0].Name;
                    this.state.addressSelected.state = response[0].Records[0].State;
                    this.state.addressSelected.line1 = response[0].Records[0].Line1;
                    this.state.addressSelected.city = response[0].Records[0].City;
                    this.state.addressSelected.country = response[0].Records[0].Country;
                    this.state.addressSelected.postCode = response[0].Records[0].PostCode;
                    document.cookie = `${this.Cooki}=${response[0].Records[0].ID}; path=/`;
                } else if (response[0].TotalRecords > 0 && cookie != undefined) {
                    var address = response[0].Records.find(x => x.ID == cookie);

                    if (address != undefined) {
                        this.addressSelection(address);
                    }
                }
            }
        });
    }

    subGetBillingAddress(
        addressId_I
    ) {
        if (
            addressId_I
        ) {
            var userId = this.props.user.ID != null ? this.props.user.ID : '';

            // Prepare promise for warehouses collection
            const promiseSucursales = new Promise((resolve, reject) => {
                const options = {
                    pluginId: this.packageIdAlmacenes,
                    tableName: 'Almacenes',
                    query: [
                        {
                            Name: 'IsActive',
                            Operator: "eq",
                            Value: "true"
                        }
                    ]
                };

                client.CustomTables.searchCustomTable(options, function(err, result) {
                    resolve(result);
                });
            });

            // Prepare promise for warehouses coonfiguration
            const promiseUserConfiguration = new Promise((resolve, reject) => {
                const options = {
                    pluginId: this.packageIdAlmacenes,
                    tableName: 'ConfiguracionUsuario',
                    query: [
                        {
                            Name: 'UserId',
                            Operator: 'equal',
                            Value: userId
                        },
                        {
                            Name: 'AddressId',
                            Operator: 'equal',
                            Value: addressId_I
                        }
                    ]
                };

                client.CustomTables.searchCustomTable(options, function(err, result) {
                    resolve(result);
                });
            });

            Promise.all([promiseSucursales, promiseUserConfiguration]).then(response => {
                let strBranchId = null;
                let strDepot = null;
                let strRegion = null;
                let strPedidoInternetId = null;
                if (
                    response[0].Records.length > 0 && response[1].Records.length > 0
                ) {
                    //                                      //To easy code.
                    const arrAlmacenes = response[0].Records;
                    const configObj = response[1].Records[0];
                    for (let intIndex = 0; intIndex < arrAlmacenes.length; intIndex++) {
                        const almacen = arrAlmacenes[intIndex];
                        if (
                            almacen.Nombre == configObj.AlmacenFacturacion
                        ) {
                            strDepot = almacen.LiderId;
                            strBranchId = almacen.BrachId;
                            strRegion = almacen.Region;
                            strPedidoInternetId = almacen.PedidoId;
                            break;
                        }
                    }
                }

                if (
                    strBranchId != null
                ) {
                    this.subSetBranchConfiguration(strBranchId, strRegion, strDepot, strPedidoInternetId);
                }
            });
        }
    }

    subSetBranchConfiguration(
        //                                                  //Set attribute and cookie for branch id and region.
        strBranchId_I,
        strRegion_I,
        strDepot_I,
        strPedidoInternetId_I
    ) {
        document.getElementById('address-name').setAttribute('billing-address-lider', strDepot_I);
        document.getElementById('address-name').setAttribute('billing-address-branch', strBranchId_I);
        document.getElementById('address-name').setAttribute('billing-address-region', strRegion_I);
        document.getElementById('address-name').setAttribute('billing-address-pedido', strPedidoInternetId_I);
        document.cookie = `${this.Cookies_SelectedAddressLider}=${strDepot_I}; path=/`;
        document.cookie = `${this.Cookies_SelectedAddressRegion}=${strRegion_I}; path=/`;
        document.cookie = `${this.Cookies_SelectedAddressDepot}=${strBranchId_I}; path=/`;
        document.cookie = `${this.Cookies_SelectedAddressPedido}=${strPedidoInternetId_I}; path=/`;
        //                                                  //Lanza evento para que los banners se ajusten
        $(document).trigger('address-region-attribute-changed');
    }

    // -----------------------------------------------------------------------------------------------------------------
    subCleanResults(
        objResponse_I
    ) {
        var response = objResponse_I;
        var records = [];
        if (response != null && response.Records != null && response.Records.length > 0) {
            response.Records.forEach(address => {
                // Pickup is used as a flag for shipping address
                if (address.Pickup) {
                    records.push(address);
                }
            });

            response.Records = records;
        }

        return response;
    }

    // -----------------------------------------------------------------------------------------------------------------
    setUserDefaultAddress() {
        const self = this;
        if (typeof this.props.user != 'undefined') {
            client.Addresses.getUserAddresses(this.props.user.ID, function(err, addresses) {
                if (
                    addresses != null && addresses.Records != null && addresses.Records.length > 0
                ) {
                    // We need to check that the default address fulfill that it is a shipping address.
                    var billingAddress = null;
                    var intValidPickupAddress = 0;
                    addresses.Records.forEach(address => {
                        if (
                            address.Pickup
                        ) {
                            intValidPickupAddress++;
                        }

                        // Storing by default the first shipping address found.
                        if (billingAddress == null && address.Pickup) {
                            billingAddress = address;
                        }
                    });

                    /*
                    TODO: (Fix bug/New approach) This piece of code had issues, since hydrate method
                    break the flow to display itself the modal, reverted to previous
                    approach, which select first shipping address found.
                    if (
                        //If user had more or equal than 2 shipping addresses ask user which to use.
                        intValidPickupAddress >= 2
                        )
                    {
                        self.setState({boolHideCloseButton:true}, () => {
                            self.displayModal();
                        });
                    }
                    else if (
                        billingAddress != null
                        )
                    {
                        self.addressSelection(billingAddress);
                        self.subGetBillingAddress(billingAddress.ID);
                    } */

                    if (
                        billingAddress != null
                    ) {
                        self.addressSelection(billingAddress);
                        self.subGetBillingAddress(billingAddress.ID);
                    }
                }
            });
        } else {
            document.getElementById('address-alias').innerText = '';
            document.getElementById('address-name').innerText = '';
            document.getElementById('address-zipcode').innerText = 'Inicia sesión para elegir una dirección';

            document.getElementById('custom-address-mobile').innerText = '';

            $('#custom-address-modal-header').css('display', 'none');
        }
    }

    // -----------------------------------------------------------------------------------------------------------------
    displayModal(modalId) {
        const pathName = window.location.pathname;
        const userDetail = this.props.user;

        if (pathName === '/cart') {
            if (userDetail &&
                userDetail.CustomFields &&
                userDetail.CustomFields.find(x => x.Name === 'Tipo de Usuario') &&
                userDetail.CustomFields.find(x => x.Name === 'Tipo de Usuario').Values[0] === 'B2C') {
                return false;
            }
        }

        this.getTableData();
        $('#modal-custom-addresbook').modal({ show: true });
        $('.modal-backdrop').hide();
        // document.getElementsByClassName("modal-backdrop")[0].style.display = "none";
    }

    returnPedidoAgil() {
        $('#modalChange').modal('hide');
        window.location = '/pedido-agil';
    }

    // -----------------------------------------------------------------------------------------------------------------
    renderModalPopUp() {
        var arrowDown = '';
        var recordsFinal = [];

        if (this.state.addressList) {
            if (this.state.addressList.TotalRecords > 0) {
                this.state.addressList.Records.forEach(address => {
                    // Pickup is used as a flag for shipping address
                    if (address.Pickup) {
                        recordsFinal.push(address);
                    }
                });
            }
        }
        // Para movil
        if ($(window).width() < 600) {
            if (this.state.addressList) {
                if (recordsFinal.length > 4) {
                    return (
                        <div className='modal fade' id='modal-custom-addresbook' tabIndex='-1' role='dialog' aria-labelledby='userEditorLabel' aria-hidden='true' style={{ display: 'none' }}>
                            <div id='modal-widget-addresses' className='modal-dialog' style={{ width: 500 + 'px', height: 400 + 'px' }} role='document'>
                                <div className='modal-content' style={{ borderRadius: 25 + 'px', height: 390 + 'px', overflow: 'scroll' }}>
                                    <div className='modal-header' style={{ marginLeft: 15 + 'px', marginBottom: -10 + 'px', borderBottom: 'none' }}>
                                        <h5 className='modal-title col-md-11' id='userEditorLabel' style={{ fontWeight: 'bold', fontSize: 23 + 'px', color: 'black' }}>Escoge una dirección</h5>
                                        <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                                            <span aria-hidden='true' className={this.state.boolHideCloseButton ? 'hide' : ''}>×</span>
                                      </button>
                                  </div>

                                    <div className='modal-body' id='modalBody' style={{ marginBottom: 25 + 'px', marginLeft: 25 + 'px', marginRight: 25 + 'px' }}>

                                        <div className='row' id='useraddresses'>
                                            {this.renderTable()}
                                      </div>

                                  </div>

                              </div>
                          </div>
                      </div>
                    );
                } else {
                    return (
                        <div className='modal fade' id='modal-custom-addresbook' tabIndex='-1' role='dialog' aria-labelledby='userEditorLabel' aria-hidden='true' style={{ display: 'none' }}>
                            <div id='modal-widget-addresses' className='modal-dialog' style={{ width: 500 + 'px' }} role='document'>
                                <div className='modal-content' style={{ borderRadius: 25 + 'px', height: 100 + '%', overflow: 'hidden' }}>
                                    <div className='modal-header' style={{ marginLeft: 15 + 'px', marginBottom: -10 + 'px', borderBottom: 'none' }}>
                                        <h5 className='modal-title col-md-11' id='userEditorLabel' style={{ fontWeight: 'bold', fontSize: 23 + 'px', color: 'black' }}>Escoge una dirección</h5>
                                        <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                                            <span aria-hidden='true' className={this.state.boolHideCloseButton ? 'hide' : ''}>×</span>
                                      </button>
                                  </div>

                                    <div className='modal-body' id='modalBody' style={{ marginBottom: 25 + 'px', marginLeft: 25 + 'px', marginRight: 25 + 'px' }}>

                                        <div className='row' id='useraddresses'>
                                            {this.renderTable()}
                                      </div>

                                  </div>

                              </div>
                          </div>
                      </div>
                    );
                }
            }
        } else {
            if (this.state.addressList) {
                if (recordsFinal.length > 5) {
                    return (
                        <div className='modal fade' id='modal-custom-addresbook' tabIndex='-1' role='dialog' aria-labelledby='userEditorLabel' aria-hidden='true' style={{ display: 'none' }}>
                            <div id='modal-widget-addresses' className='modal-dialog' style={{ width: 500 + 'px', height: 620 + 'px' }} role='document'>
                                <div className='modal-content' style={{ borderRadius: 25 + 'px', height: 620 + 'px', overflow: 'scroll' }}>
                                    <div className='modal-header' style={{ marginLeft: 15 + 'px', marginBottom: -10 + 'px', borderBottom: 'none' }}>
                                        <h5 className='modal-title col-md-11' id='userEditorLabel' style={{ fontWeight: 'bold', fontSize: 23 + 'px', color: 'black' }}>Escoge una dirección</h5>
                                        <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                                            <span aria-hidden='true' className={this.state.boolHideCloseButton ? 'hide' : ''}>×</span>
                                      </button>
                                  </div>

                                    <div className='modal-body' id='modalBody' style={{ marginBottom: 25 + 'px', marginLeft: 25 + 'px', marginRight: 25 + 'px' }}>

                                        <div className='row' id='useraddresses'>
                                            {this.renderTable()}
                                      </div>

                                  </div>

                              </div>
                          </div>
                      </div>
                    );
                } else {
                    return (
                        <div className='modal fade' id='modal-custom-addresbook' tabIndex='-1' role='dialog' aria-labelledby='userEditorLabel' aria-hidden='true' style={{ display: 'none' }}>
                            <div id='modal-widget-addresses' className='modal-dialog' style={{ width: 500 + 'px' }} role='document'>
                                <div className='modal-content' style={{ borderRadius: 25 + 'px', height: 100 + '%', overflow: 'hidden' }}>
                                    <div className='modal-header' style={{ marginLeft: 15 + 'px', marginBottom: -10 + 'px', borderBottom: 'none' }}>
                                        <h5 className='modal-title col-md-11' id='userEditorLabel' style={{ fontWeight: 'bold', fontSize: 23 + 'px', color: 'black' }}>Escoge una dirección</h5>
                                        <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                                            <span aria-hidden='true' className={this.state.boolHideCloseButton ? 'hide' : ''}>×</span>
                                      </button>
                                  </div>

                                    <div className='modal-body' id='modalBody' style={{ marginBottom: 25 + 'px', marginLeft: 25 + 'px', marginRight: 25 + 'px' }}>

                                        <div className='row' id='useraddresses'>
                                            {this.renderTable()}
                                      </div>

                                  </div>

                              </div>
                          </div>
                      </div>
                    );
                }
            }
        }

        // console.log("this.renderModalPopUp");
    }

    // -----------------------------------------------------------------------------------------------------------------
    render() {
        return (
            <React.Fragment>
                <div>
                    <a className='custom-address-link' onClick={() => this.displayModal()}>
                        <div className='custom-address-container'>
                            <div>
                            <img alt="" id='icon-address' src='/assets/images/bepensa/icon-address.svg' />
                          </div>
                            <div id='addresses-selected' style={{ display: 'flex', flexDirection: 'column' }}>
                                <span id='address-alias' /> <span>  </span>
                                <span id='address-name' /> <span>  </span>
                                <input type="hidden" id="address-line1" value="" />
                                <input type="hidden" id="address-lideriduser" value="" />
                                <span id='address-zipcode'>Seleccionar dirección</span>
                          </div>
                            <div id='addresses-selected-mobile'>
                                <div id='custom-address-mobile' />
                          </div>
                      </div>
                  </a>

              </div>
                {this.renderModalPopUp()}

                <div id='modalChange' className='modal fade' role='dialog' data-backdrop='static' data-keyboard='false'>
                    <div className='modal-dialog delete-modal-content'>
                        <div className='modal-content'>
                            <div className='modal-body' style={{ color: 'black' }}>
                                <p>Si cambias de dirección, se reiniciará el flujo. ¿Estás seguro de cancelar el proceso?</p>
                          </div>
                            <div className='modal-footer'>
                                <div className='btn-gray' data-dismiss='modal'>Cancelar</div>
                                <div className='btn-green' id='modalChange' onClick={(e) => this.returnPedidoAgil()}>Ok</div>
                          </div>
                      </div>
                  </div>
              </div>
          </React.Fragment>
        );
    }
}
//= ====================================================================================================================

module.exports = AddressModalComponent;
